import { apiRequest } from "../util/apiUtils";

export const userList = async (params) => {
  try {
    const res = await apiRequest("get", `user/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `user/backend/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userDetails = async (payload) => {
  try {
    const res = await apiRequest("get", `user/backend/detail/${payload?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userDelete = async (payload) => {
  try {
    const res = await apiRequest("patch", `user/backend/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `user/backend/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const userPasswordChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `user/backend/admin-password-change`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
